// extracted by mini-css-extract-plugin
export default {"input":"kca-z","button":"lca-z","selected":"mca-z","unavailable":"nca-z","oos":"oca-z","paperCutDisabledOverlay":"pca-z","image":"qca-z"};